<template>
    <template v-if="loader_loading">
        <div class="container">
            <br />
            <div class="text-center text-muted">
                <font-awesome-icon icon="fas fa-circle-notch" size="2x" spin />
                <p>Loading data</p>
            </div>
        </div>
    </template>

    <template v-if="!voucher_list.length && !my_voucher_list.length && !loader_loading">
        <div class="card">
            <div class="card-body">
                <h4 class="text-muted text-center mb-0">No data available</h4>
            </div>
        </div>
    </template>

    <template v-if="!loader_loading">
        <div v-if="my_voucher_list.length">
            <div class="container">
                <h5 class="mb-0 cs-text-gradient">My Vouchers</h5>
                <p class="fst-italic text-body-tertiary mb-3">
                    <small>Use your collected voucher before it expired</small>
                </p>

                <div class="row align-items-end">
                    <div v-for="record in my_voucher_list" class="col-4">
                        <template v-if="record.status == 13">
                            <small>
                                <span :class="$parent.generateRecordStatusClass(record.status)" class="badge rounded-pill w-100">{{ record.status_str }}</span>
                            </small>
                        </template>

                        <template v-if="record.status != 13 && record.time_left">
                            <small class="text-center">
                                <span class="badge rounded-pill text-bg-danger w-100">{{ record.time_left }}</span>
                            </small>
                        </template>

                        <div @click="openBottomSheet('VIEW_DETAIL', record.id)" :class="{ 'cs-card-disabled': record.status != 11 }" class="card border-0 shadow-sm">
                            <img v-if="record.voucher_data.img_json && record.voucher_data.img_json['1_1']" :src="record.voucher_data.img_json['1_1']" class="card-img" />
                        </div>
                    </div>

                    <div v-if="my_voucher_list.length < 1" class="col-4 align-self-center">
                        <div class="mx-auto rounded-4" style="width: 5.5rem; height: 5.5rem; background-color: #e6e6e6"></div>
                    </div>

                    <div v-if="my_voucher_list.length < 2" class="col-4 align-self-center">
                        <div class="mx-auto rounded-4" style="width: 5.5rem; height: 5.5rem; background-color: #e6e6e6"></div>
                    </div>

                    <div class="col-4 align-self-center">
                        <div @click="$parent.redirectToMyVoucher()" class="card text-center shadow-sm rounded-4 mx-auto" style="border-width: 0; height: 5.5rem; width: 5.5rem">
                            <div class="card-body p-2 d-flex align-items-center mx-auto">
                                <small class="fw-bold mb-0 cs-text-gradient">
                                    View All
                                    <br />
                                    <span style="line-height: 1.5rem; color: #f46b27">
                                        <font-awesome-icon icon="fas fa-arrow-right" size="lg" />
                                    </span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
            </div>
        </div>

        <div v-if="voucher_list.length" class="bg-white">
            <div class="container">
                <br />
                <h3 class="mb-3">Vouchers</h3>
                <!-- <p class="fst-italic text-body-tertiary mb-3">
                    <small>List of available vouchers</small>
                </p> -->

                <div :class="{ 'cs-card-disabled': !voucher.display_status }" v-for="voucher in voucher_list" @click="goToVoucherDetail(voucher.short_id)" class="card border-0 cs-shadow mb-3 position-relative">
                    <img v-if="voucher.img_json && voucher.img_json['2_1']" :src="voucher.img_json['2_1']" class="card-img" />
                    <div class="position-absolute bottom-0 end-0 translate-middle">
                        <span v-if="voucher.display_status && voucher.stock != 99999 && voucher.stock < 10">
                            <small class="text-body-tertiary text-opacity-25 fst-italic"> {{ voucher.stock }} left </small>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <RecordDetail title="Voucher Detail" ref="voucher" :record_data="record_data">
        </RecordDetail>
    </template>
</template>

<script>
import RecordDetail from '../components/_bottom_sheet/RecordDetail.vue';

export default {
    components: {
        RecordDetail,
    },
    data() {
        return {
            voucher_list: [],
            my_voucher_list: [],
            record_data: {},
            bottom_sheet: "",
            loader_loading: false,
        };
    },
    mounted() {
        this.initMainFunction();
    },
    methods: {
        initMainFunction() {
            this.loadData();
            return true;
        },

        loadData() {
            this.reloadUi();
        },

        reloadUi() {
            this.loader_loading = true;

            return app.readAllVoucher(app.device_tag).then(response_data => {
                if (app.first_entry) {
                    app.updateVoucherView();
                }

                if (response_data) {
                    this.voucher_list = response_data;
                }

                return app.readAllRecordHomepage(app.device_tag).then(response_data => {
                    this.loader_loading = false;

                    if (!response_data) {
                        return false;
                    }

                    this.my_voucher_list = response_data;

                    return true;
                });
            });
        },

        openBottomSheet(name, params = {}) {
            switch (name) {
                case "VIEW_DETAIL":
                    this.bottom_sheet = "";
                    this.qr_image = "";
                    this.record_data = {};

                    return app.readRecordDetail(app.device_tag, params).then(response_data => {
                        if (!response_data) {
                            return false;
                        }

                        this.record_data = response_data;

                        var bottom_sheet_option = {
                            keyboard: false,
                        };

                        this.bottom_sheet = new bootstrap.Offcanvas(document.querySelector("#record_detail_bottom_sheet"), bottom_sheet_option);
                        this.bottom_sheet.show();
                        return true;
                    });

                    break;
            }
        },

        goToVoucherDetail(voucher_short_id) {
            app.voucher_short_id = voucher_short_id;
            app.redirectToVoucherDetail();
        },

        goToRecordDetail(record_id) {
            app.record_id = record_id;
            app.redirectToRecordDetail();
        },
    },
};
</script>
